var _g, _path, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNoBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 1000,
    height: 623,
    viewBox: "0 0 1000 623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.6060606060606233,0.2522267206477409)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 247",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: 623,
    width: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.2400000000000091,-0.09999999999999432)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M55.039 247.2l28.602-49.541 1.534 0-27.793 48.14h280.756l-27.793-48.14 1.534 0 28.602 49.541zM197.76 0l28.602 49.541-1.534 0-27.068-46.884-27.068 46.884-1.534 0z",
    fill: "#00ff19",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    },
    "data-fill-palette-color": "tertiary"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,70.70043225387019)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 105.79913549225961",
    height: 105.79913549225961,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 105.79913549225961",
    height: 105.79913549225961,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 105.79913549225961",
    height: 105.79913549225961,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 105.79913549225961",
    height: 105.79913549225961,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 73.50413016826923,
    fill: "none",
    strokeWidth: 4.05814644,
    stroke: "#00ff19",
    "data-fill-palette-color": "none",
    "data-stroke-palette-color": "tertiary"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 32.29500532399038,
    y: 73.50413016826923,
    fill: "#00ff19",
    "data-fill-palette-color": "tertiary"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 73.50413016826923",
    height: 73.50413016826923,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.62342,10.62342)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 374.27315999999996,
    viewBox: "2.5999999046325684 -34.54999923706055 249.58999633789062 34.849998474121094",
    height: 52.25729016826923,
    "data-palette-color": "#00ff19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.15-7.85L33.15-7.85Q35.1-7.85 35.85-9.98 36.6-12.1 36.6-16.9L36.6-16.9 36.7-29.15Q36.7-31.8 37.93-33.02 39.15-34.25 42.15-34.25L42.15-34.25Q44-34.25 45.13-33.65 46.25-33.05 47.05-31.3 47.85-29.55 48.15-26.55 48.45-23.55 48.45-18.6L48.45-18.6Q48.45-15.65 47.95-13.1 47.45-10.55 46.6-8.65 45.75-6.75 44.58-5.23 43.4-3.7 42.1-2.7 40.8-1.7 39.35-1.03 37.9-0.35 36.52-0.08 35.15 0.2 33.85 0.2L33.85 0.2Q29.35 0.2 25.7-2.65L25.7-2.65Q22.1 0.3 17.55 0.3L17.55 0.3Q15.6 0.3 13.65-0.28 11.7-0.85 9.68-2.25 7.65-3.65 6.1-5.73 4.55-7.8 3.58-11.13 2.6-14.45 2.6-18.5L2.6-18.5Q2.6-25.05 3.23-28.4 3.85-31.75 5.13-32.95 6.4-34.15 8.85-34.15L8.85-34.15Q10.9-34.15 12.1-33.58 13.3-33 13.8-31.9 14.3-30.8 14.3-29.05L14.3-29.05 14.35-16.85Q14.35-12.05 15.1-9.9 15.85-7.75 18.05-7.75L18.05-7.75Q19.15-7.75 19.7-8.68 20.25-9.6 20.45-11.65L20.45-11.65Q19.8-14.55 19.8-20.7L19.8-20.7Q19.8-24.15 19.95-26.2 20.1-28.25 20.4-29.75 20.7-31.25 21.4-31.9 22.1-32.55 22.98-32.83 23.85-33.1 25.4-33.1L25.4-33.1Q26.3-33.1 26.98-33.05 27.65-33 28.25-32.75 28.85-32.5 29.25-32.3 29.65-32.1 30-31.55 30.35-31 30.55-30.6 30.75-30.2 30.93-29.3 31.1-28.4 31.18-27.73 31.25-27.05 31.28-25.73 31.3-24.4 31.33-23.43 31.35-22.45 31.35-20.65L31.35-20.65Q31.35-14.35 30.7-11.35L30.7-11.35Q30.9-9.55 31.45-8.7 32-7.85 33.15-7.85ZM71.1-7L71.1-7Q72.8-7 74.02-8.5 75.25-10 75.77-12.2 76.3-14.4 76.3-16.9L76.3-16.9Q76.3-19.45 75.75-21.73 75.2-24 73.97-25.6 72.75-27.2 71.1-27.2L71.1-27.2Q69.5-27.2 68.3-25.6 67.1-24 66.5-21.7 65.9-19.4 65.9-16.9L65.9-16.9Q65.9-14.4 66.47-12.2 67.05-10 68.27-8.5 69.5-7 71.1-7ZM79.95-1.68Q76 0.3 71.07 0.3 66.15 0.3 62.22-1.68 58.3-3.65 55.95-7.6 53.6-11.55 53.6-16.9L53.6-16.9Q53.6-25 58.47-29.78 63.35-34.55 71.1-34.55 78.85-34.55 83.75-29.78 88.65-25 88.65-16.9L88.65-16.9Q88.65-11.55 86.27-7.6 83.9-3.65 79.95-1.68ZM124.4-7.85L124.4-7.85Q126.34-7.85 127.09-9.98 127.84-12.1 127.84-16.9L127.84-16.9 127.95-29.15Q127.95-31.8 129.17-33.02 130.4-34.25 133.4-34.25L133.4-34.25Q135.25-34.25 136.37-33.65 137.5-33.05 138.3-31.3 139.09-29.55 139.4-26.55 139.69-23.55 139.69-18.6L139.69-18.6Q139.69-15.65 139.19-13.1 138.69-10.55 137.84-8.65 137-6.75 135.82-5.23 134.65-3.7 133.34-2.7 132.05-1.7 130.59-1.03 129.15-0.35 127.77-0.08 126.4 0.2 125.09 0.2L125.09 0.2Q120.59 0.2 116.95-2.65L116.95-2.65Q113.34 0.3 108.8 0.3L108.8 0.3Q106.84 0.3 104.9-0.28 102.95-0.85 100.92-2.25 98.9-3.65 97.34-5.73 95.8-7.8 94.82-11.13 93.84-14.45 93.84-18.5L93.84-18.5Q93.84-25.05 94.47-28.4 95.09-31.75 96.37-32.95 97.65-34.15 100.09-34.15L100.09-34.15Q102.15-34.15 103.34-33.58 104.55-33 105.05-31.9 105.55-30.8 105.55-29.05L105.55-29.05 105.59-16.85Q105.59-12.05 106.34-9.9 107.09-7.75 109.3-7.75L109.3-7.75Q110.4-7.75 110.95-8.68 111.5-9.6 111.7-11.65L111.7-11.65Q111.05-14.55 111.05-20.7L111.05-20.7Q111.05-24.15 111.2-26.2 111.34-28.25 111.65-29.75 111.95-31.25 112.65-31.9 113.34-32.55 114.22-32.83 115.09-33.1 116.65-33.1L116.65-33.1Q117.55-33.1 118.22-33.05 118.9-33 119.5-32.75 120.09-32.5 120.5-32.3 120.9-32.1 121.25-31.55 121.59-31 121.8-30.6 122-30.2 122.17-29.3 122.34-28.4 122.42-27.73 122.5-27.05 122.52-25.73 122.55-24.4 122.57-23.43 122.59-22.45 122.59-20.65L122.59-20.65Q122.59-14.35 121.95-11.35L121.95-11.35Q122.15-9.55 122.7-8.7 123.25-7.85 124.4-7.85ZM162.34-7L162.34-7Q164.04-7 165.27-8.5 166.49-10 167.02-12.2 167.54-14.4 167.54-16.9L167.54-16.9Q167.54-19.45 166.99-21.73 166.44-24 165.22-25.6 163.99-27.2 162.34-27.2L162.34-27.2Q160.74-27.2 159.54-25.6 158.34-24 157.74-21.7 157.14-19.4 157.14-16.9L157.14-16.9Q157.14-14.4 157.72-12.2 158.29-10 159.52-8.5 160.74-7 162.34-7ZM171.19-1.68Q167.24 0.3 162.32 0.3 157.39 0.3 153.47-1.68 149.54-3.65 147.19-7.6 144.84-11.55 144.84-16.9L144.84-16.9Q144.84-25 149.72-29.78 154.59-34.55 162.34-34.55 170.09-34.55 174.99-29.78 179.89-25 179.89-16.9L179.89-16.9Q179.89-11.55 177.52-7.6 175.14-3.65 171.19-1.68ZM204.69-24.3L204.69-24.3Q204.69-26.7 202.94-27.6 201.19-28.5 197.04-28.5L197.04-28.5 197.04-19.85Q200.94-19.85 202.81-20.83 204.69-21.8 204.69-24.3ZM197.04-12.35L197.04-7.5Q197.04 0 191.19 0L191.19 0Q188.24 0 186.87-1.58 185.49-3.15 185.49-7.15L185.49-7.15 185.49-28.25Q185.49-31.15 187.06-32.68 188.64-34.2 191.19-34.2L191.19-34.2 201.69-34.2Q207.84-34.2 211.64-31.33 215.44-28.45 215.44-23.95L215.44-23.95Q215.44-20.55 214.02-18.63 212.59-16.7 209.44-15.8L209.44-15.8Q211.84-15.65 213.89-13.48 215.94-11.3 215.94-8.05L215.94-8.05Q215.94-4.75 215.31-2.98 214.69-1.2 213.54-0.6 212.39 0 210.29 0L210.29 0Q207.34 0 205.97-1.23 204.59-2.45 204.59-4.95L204.59-4.95Q204.59-8.05 203.99-9.73 203.39-11.4 202.44-11.9 201.49-12.4 199.79-12.4L199.79-12.4 197.04-12.35ZM233.44-27.25L233.44-6.8Q234.74-6.8 235.71-7.08 236.69-7.35 237.56-8.08 238.44-8.8 238.99-10 239.54-11.2 239.86-13.08 240.19-14.95 240.19-17.5L240.19-17.5Q240.19-20.35 239.69-22.33 239.19-24.3 238.24-25.33 237.29-26.35 236.16-26.78 235.04-27.2 233.44-27.25L233.44-27.25ZM227.59-34.2L234.94-34.2Q242.74-34.2 247.46-29.7 252.19-25.2 252.19-17.3L252.19-17.3Q252.19-14.75 251.71-12.35 251.24-9.95 250.14-7.68 249.04-5.4 247.39-3.73 245.74-2.05 243.19-1.03 240.64 0 237.44 0L237.44 0 227.59 0Q224.54 0 223.21-1.55 221.89-3.1 221.89-7.15L221.89-7.15 221.89-28.25Q221.89-34.2 227.59-34.2L227.59-34.2Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#00ff19",
    className: "undefined-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 247.2,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoBackground);
export default __webpack_public_path__ + "static/media/logo-no-background.976ad1179d55018804e051883e0beed3.svg";
export { ForwardRef as ReactComponent };